import { autoResizeParent, getUrlVars, parentRedirect, parentScrollToTheTop } from '../utils/utils'
import './profiles.scss'

export default class Profiles
  constructor: (@app) ->
    ready = =>
      if $('body[data-controller="profile"]').length > 0
        @_initForgotPasswordLink()
        @_initSuccessfulLoginURL()
        @_adjustIframeWidthOnFrameLoad()

      if $('body[data-controller="profile"][data-action="home"]').length > 0
        @_initHomeFrame()

      onIframedPage = $('body[data-controller="profile"]')
        .filter('[data-action="join"], [data-action="home"]')
        .length > 0
      if onIframedPage
        @_showLoader()
        window.profile_window_loaded = @_hideLoader
        window.profileCreated = @_profileCreated
        setInterval(autoResizeParent, 250)
    $(document).ready(ready)
    $(document).on('page:load', ready)

  # If the profiles dialog is responsive the width should be 100%, otherwise it
  # should be a fixed width. We can retire this method once we no longer have
  # non-responsive Profiles Dialog apps in production (only profiles6 and up)
  _adjustIframeWidth: ->
    try
      $iframe = $('#profile_iframe')
      parentFrame = window.frameElement
      contentWidth = $iframe.contents().width()
      frameWidth = $iframe.width()
      isResponsive = contentWidth == frameWidth

      if isResponsive
        $iframe.css('width', '100%')
        parentFrame.style.width = '100%' if parentFrame?
      else
        $iframe.css('width', '820px')
        parentFrame.style.width = '830px' if parentFrame?
    catch
      null

  _adjustIframeWidthOnFrameLoad: ->
    return unless $('#profile_iframe').length
    checkFrameLoad = =>
      # If we can access the iframe contents then it must have loaded.
      if $('#profile_iframe').contents().find('body div').length
        clearInterval @frameLoadInterval
        @_adjustIframeWidth()
    @frameLoadInterval = window.setInterval(checkFrameLoad, 400)

  _initForgotPasswordLink: ->
    try
      url = $(window.frameElement).data('ma-forgot-password-url')
    catch
      null
    url = @app.url('parent_forgot_password') if !url

    $('#forgot-password').click =>
      window.parent.window.postMessage("page_redirect=#{url}", '*')

  _initHomeFrame: ->
    # Below line can be removed once everybody is on the new CRM plugin
    try
      progs = $(window.frameElement).data('ma-allowed-programs')
    catch
      null

    if !progs
      progs = @app.config('allowed-programs')

    $('iframe').attr('data-pr-allowed-programs', progs) if progs

  _initSuccessfulLoginURL: ->
    # Below line can be removed once everybody is on the new CRM plugin
    try
      url = $(window.frameElement).data('ma-after-login-url')
    catch
      null

    if !url
      url = @app.url('after_login')

    $('input[name=after_login_url]').val(url)

  _hideLoader: =>
    @app.parentDocument?().getElementById('loading')?.style.visibility = 'hidden'

  _profileCreated: (username, password) =>
    parentScrollToTheTop(true)

    # Below line can be removed once everybody is on the new CRM plugin
    try
      redirectOnCreate = $(window.frameElement).data('ma-after-profile-created-url')
    catch
      null
    
    if !redirectOnCreate
      redirectOnCreate = @app.url('after_profile_created')
    
    urlParam = getUrlVars()['afterCreateUrl']
    if urlParam
      redirectFn = => window.location = urlParam
    else if redirectOnCreate
      $('iframe').css('visibility', 'hidden')
      redirectFn = => parentRedirect(redirectOnCreate)

    $.get @app.url('reload_profile'), {username, password},
      (data) => redirectFn() if redirectFn

  _showLoader: ->
    @app.parentDocument()?.getElementById('loading')?.style.visibility = 'visible'
